// src/pages/Analytics.js
import React from "react";
import { motion } from "framer-motion";
import Analytics from "../components/Analytics";


const AnalyticsPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      transition={{ duration: 0.5 }}
    >
      <Analytics />
    </motion.div>
  );
};

export default AnalyticsPage;